import { render } from "./LearningStart.vue?vue&type=template&id=6509d33c"
import script from "./LearningStart.vue?vue&type=script&lang=ts"
export * from "./LearningStart.vue?vue&type=script&lang=ts"
script.render = render

export default script